import React from "react";
import { cn } from "../../../../utils/cn";
import type { AgendaWeekSummary } from "../../agendaTypes";
import {
  getFortalezaTodayIso,
  normalizeAgendaIsoDate,
} from "../../agendaFiltersQuery";

type MobileWeekStripProps = {
  selectedDateIso: string;
  weekSummary: AgendaWeekSummary;
  onSelectDate: (isoDate: string) => void;
};

const MobileWeekStrip: React.FC<MobileWeekStripProps> = ({
  selectedDateIso,
  weekSummary,
  onSelectDate,
}) => {
  const todayIso = getFortalezaTodayIso();
  const normalizedSelectedDate =
    normalizeAgendaIsoDate(selectedDateIso) ?? selectedDateIso;
  return (
    <div className="mb-4 flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      {weekSummary.days.map((day) => {
        const dayIso = normalizeAgendaIsoDate(day.date) ?? day.date;
        const isSelected = dayIso === normalizedSelectedDate;
        const isToday = dayIso === todayIso;
        const isPast = dayIso < todayIso;

        return (
          <button
            key={day.date}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelectDate(day.date)}
            className={cn(
              "relative flex min-h-[76px] min-w-[68px] shrink-0 flex-col items-center justify-center rounded-2xl border px-3 py-3 text-center transition",
              isSelected
                ? "border-[#2D3748] bg-[#2D3748] text-white"
                : isPast
                  ? "border-dashed border-[#E2E8F0] bg-[#F7FAFC] text-[#A0AEC0]"
                  : "border-[#E2E8F0] bg-white text-[#4A5568]"
            )}
          >
            <span className="text-[11px] font-bold uppercase leading-none tracking-wide">
              {day.weekday_label}
            </span>
            <span className="mt-2 text-lg font-bold leading-none">
              {day.day_of_month}
            </span>
            {isToday && !isSelected ? (
              <span
                className="absolute bottom-2 h-1.5 w-1.5 rounded-full bg-[#c4552b]"
                aria-hidden
              />
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default MobileWeekStrip;
